import { NotificationMessage } from '@map/types';
import useAction from '@shared/hooks/useAction';
import { Reducer } from 'redux';

const initialState = [] as NotificationMessage[];

type State = typeof initialState;

const SHOW_MESSAGE = 'NOTIFICATIONS_ADD_MESSAGE';
const HIDE_MESSAGE = 'NOTIFICATIONS_HIDE_MESSAGE';

export const actionCreators = {
  showMessage: (message: Omit<NotificationMessage, 'id'>) =>
    ({ type: SHOW_MESSAGE, message }) as const,
  hideMessage: (message: NotificationMessage) => ({ type: HIDE_MESSAGE, message }) as const,
};

type Action = ReturnType<(typeof actionCreators)[keyof typeof actionCreators]>;
let nextMessageId = 0;

const notifications: Reducer<State, Action> = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MESSAGE: {
      const lastMessage = state[state.length - 1];
      if (
        lastMessage &&
        lastMessage.text === action.message.text &&
        lastMessage.type === action.message.type &&
        lastMessage.textKey === action.message.textKey
      ) {
        return state.map((message) =>
          // we still increment the id of the message to keep the notification visible for longer
          message === lastMessage ? { ...message, id: nextMessageId++ } : message,
        );
      }
      return [...state, { ...action.message, id: nextMessageId++ }];
    }
    case HIDE_MESSAGE:
      return state.filter((message) => message.id !== action.message.id);
    default:
      return state;
  }
};

export default notifications;

// SELECTORS

export const notificationsSelector = (state: { notifications: State }) => state.notifications;

export const useShowMessage = () => useAction(actionCreators.showMessage);

export const useHideMessage = () => useAction(actionCreators.hideMessage);
